export type SelectablePdkSystem = {
  system_id: string;
  organization_id: string;
  name: string;
  permission: string;
  cloud_node_count: number | null;
  online_cloud_node_count: number | null;
  inventory_status: 'available' | 'unavailable';
};

export function selectablePdkSystems(organizations: any[]): SelectablePdkSystem[] {
  const byId = new Map<string, SelectablePdkSystem>();
  const visit = (organization: any) => {
    if (!organization || typeof organization !== 'object') return;
    const systemId = String(organization.systemId || organization.system_id || '').trim();
    if (systemId) {
      const normalized = Object.prototype.hasOwnProperty.call(organization, 'cloud_node_count');
      const hasInventory = normalized || Array.isArray(organization.panels);
      const panels = Array.isArray(organization.panels) ? organization.panels : [];
      const next: SelectablePdkSystem = {
        system_id: systemId,
        organization_id: String(organization.organization_id || organization.id || organization._id || ''),
        name: String(organization.name || 'PDK System'),
        permission: String(organization.userPermissionLevel || organization.permission || ''),
        cloud_node_count: normalized ? organization.cloud_node_count : (hasInventory ? panels.length : null),
        online_cloud_node_count: normalized ? organization.online_cloud_node_count : (hasInventory ? panels.filter((panel: any) => panel?.online === true).length : null),
        inventory_status: hasInventory && organization.inventory_status !== 'unavailable' ? 'available' : 'unavailable',
      };
      const current = byId.get(systemId);
      if (!current || (next.cloud_node_count !== null && current.cloud_node_count === null)) byId.set(systemId, next);
    }
    if (Array.isArray(organization.children)) organization.children.forEach(visit);
  };
  (Array.isArray(organizations) ? organizations : []).forEach(visit);
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name));
}
